import { Expose, Exclude } from 'class-transformer';

@Exclude()
export class Embryo {
  @Expose()
  category: string;

  @Expose()
  animalId: number;

  @Expose()
  animalLpid: string;

  @Expose()
  embryoTransferId: number;

  @Expose()
  matingId: number;

  @Expose()
  recipId: number;

  @Expose()
  recipLpid: string;

  @Expose()
  transDate: Date;

  @Expose()
  recordValidationStatus: number;

  @Expose()
  sourceSystemId: number;

  @Expose()
  sourceCode: string;

  @Expose()
  submissionId: number;
}
